export const colors = {
  transparent: "transparent",
  black: "#000",
  white: "#fff",
  white500: "rgba(255, 255, 255, 0.5)",
  transparent100: "rgba(0, 0, 0, 0.1)",
  transparent200: "rgba(0, 0, 0, 0.2)",

  cream: "#F9F9F0",
  warmGreyHalf: "#F3F1E3",
  warmGrey: "#EAE8DD",
  cream200: "#CECCC2",

  cyan: "#8DDEE7",
  cyanAccent: "#98E6EF",
  cyanLight: "#DDF5F8",
  cyanQuarter: "#EEF9FD",
  cyanZero: "#8DDEE700",

  navy: "#0F1746",

  pink: "#FFBAF3",
  pinkAccent: "#FCC3F2",
  pinkLight: "#FFEAFB",
  pinkVivid: "#ff8afd",

  green: "#C6EAB3",
  greenAccent: "#D4EDAD",
  greenLight: "#EEF8DE",

  yellow: "#F4F39F",
  yellowAccent: "#FAF9B9",
  yellowLight: "#FCFBE2",

  brown: "#BC9D7C",

  outline: "rgba(0, 0, 0, 0.15)",
  outline2: "#EAE8DD",

  text: "#0F1746",
  text2: "rgba(0, 0, 0, 0.55)",
  text3: "rgba(0, 0, 0, 0.25)",
  text4: "rgba(0, 0, 0, 0.15)",

  gray: "#78767C",

  dataviz: {
    monthly: "#8DDEE7",
    quarterly: "#C6EAB3",
    annual: "#F4F39F",
    biannual: "#BC9D7C",
    oneOff: "#FFBAF3",
  },

  // Deprecated
  brand500: "#5CC1BF",

  red50: "#FEEDE9",
  red100: "#FCDBD3",
  red200: "#F9B7A6",
  red300: "#F78F76",
  red400: "#F3623E",
  red500: "#D14927",
  red600: "#A63A1F",
  red700: "#7E2C17",
  red800: "#852e19",
  red900: "#662313",

  yellow50: "#FFFAE6",
  yellow100: "#FFF4CC",
  yellow200: "#ffe68a",
  yellow300: "#ffda54",
  yellow400: "#ffd333",
  yellow500: "#ffc800",
  yellow600: "#e8b600",
  yellow700: "#a16207",
  yellow800: "#874c04",
  yellow900: "#673a03",

  green50: "#E4F5E4",
  green100: "#C9ECC9",
  green200: "#90D790",
  green300: "#52C152",
  green400: "#0BA80B",
  green500: "#008E00",
  green600: "#007D00",
  green700: "#006E00",
  green800: "#005a00",
  green900: "#004500",

  blue50: "#DDF5F8",
  blue100: "#C8E7F7",
  blue200: "#bfcef5",
  blue300: "#a2b7f1",
  blue400: "#90a9ee",
  blue500: "#4053C4",
  blue600: "#4053C4",
  blue700: "#3633AE",
  blue800: "#252378",
  blue900: "#161546",
} as const;

export const easing = {
  standard: "cubic-bezier(0.2, 0, 0, 1)",
  accelerate: "cubic-bezier(0.2, 0, 1, 1)",
  decelerate: "cubic-bezier(0, 0, 0, 1)",
  emphasizedDecelerate: "cubic-bezier(0.05, 0.7, 0.1, 1.0)",
  emphasizedAccelerate: "cubic-bezier(0.3, 0.0, 0.8, 0.15)",
} as const;

export const fonts = {
  switzer: `"Switzer", system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`,
  ftHabit: `"FT Habit", "Futura", "Switzer", system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`,
};

export const shadows = {
  sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
  base: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
  lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
  "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
  inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
};
